import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const PLACEHOLDER = [
  "得意なこと等をご記入ください",
  "",
  "※機密情報・顧客情報・個人を特定できる情報は記載しないでください",
].join("\n");

export default function SelfPromotionForm({ formData, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const characterCount = formData.self_promotion
    ? formData.self_promotion.length
    : 0;

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        自己PR
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={8}
        id="self_promotion"
        name="self_promotion"
        value={formData.self_promotion || ""}
        onChange={handleChange}
        placeholder={PLACEHOLDER}
        variant="outlined"
        margin="normal"
        helperText={`${characterCount}文字`}
        FormHelperTextProps={{
          sx: {
            textAlign: "right",
            marginRight: "0",
          },
        }}
        sx={{
          "& textarea:focus": {
            boxShadow: "none",
          },
        }}
      />
    </Box>
  );
}
